<style>
    #app:not(.mobile).bingo iframe{
        height: 1000px;
    }
</style>
<template>
	<div class="app flex-row align-items-center">
		<div class="container-fluid">
            <div class="client-app-inc" style="height:200px" v-if="loading">
                <Loader></Loader>
            </div>
			<slot v-if="!loading">
                <slot v-if="!_.isNull(error)">
                    <div class="container" style="padding:0 20px !important">
                        <div class="alert" style="margin:67px 0">
                            <h2>{{ error }}</h2>
                        </div>
                    </div>
                </slot>
                <slot v-else>
                    <div v-if="is_script" v-html-js="{html: game_data, script:'javascript'}"></div>
                    <iframe v-if="!is_script" :src="game_url" style="height:1000px" frameborder="0" width="100%"/>
                </slot>
            </slot>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'Beton',
        data: function() {
            return {
                loading: false,
                game_url: null,
                game_data: null,
                error: null,
                is_script: false,
            }
        },
        created: function () {
            this.fetchData();
        },

        methods: {
            fetchData: function() {
                this.loading = true;
                axios.get('/games/bingo/launch', { params: { mobile : this.isMobile }})
                .then((response)=>{
                    if(response.data.status){
                        this.is_script = response.data.config.is_script
                        if(this.is_script){
                            this.game_data = response.data.data
                        }else{
                            this.game_url = response.data.config.url
                        }   
                    }  
                })
                .catch((err)=>{
                    this.error = err.response.data.message;
                })
                .finally(() => {
                    this.loading = false;
                });

            },

        }
    }
</script>